"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
exports.__esModule = true;
exports.decodeERC1155OperationId = exports.encodeERC1155OperationId = exports.decodeERC721OperationId = exports.encodeERC721OperationId = void 0;
function encodeERC721OperationId(nftId, hash, type) {
    return "".concat(nftId, "-").concat(hash, "-").concat(type);
}
exports.encodeERC721OperationId = encodeERC721OperationId;
function decodeERC721OperationId(id) {
    var _a = __read(id.split("-"), 3), nftId = _a[0], hash = _a[1], type = _a[2];
    return {
        nftId: nftId,
        hash: hash,
        type: type
    };
}
exports.decodeERC721OperationId = decodeERC721OperationId;
function encodeERC1155OperationId(nftId, hash, type, i, j) {
    if (i === void 0) { i = 0; }
    if (j === void 0) { j = 0; }
    return "".concat(nftId, "-").concat(hash, "-").concat(type, "-i").concat(i, "_").concat(j);
}
exports.encodeERC1155OperationId = encodeERC1155OperationId;
function decodeERC1155OperationId(id) {
    var _a = __read(id.split("-"), 5), nftId = _a[0], hash = _a[1], type = _a[2], i = _a[3], j = _a[4];
    return {
        nftId: nftId,
        hash: hash,
        type: type,
        i: Number(i),
        j: Number(j)
    };
}
exports.decodeERC1155OperationId = decodeERC1155OperationId;
//# sourceMappingURL=nftOperationId.js.map